import { createBrowserRouter, Navigate, useLocation } from 'react-router-dom';
import App from './App';
import TranscriberHistory from './pages/History/transcriberHistory';
import DeletedMeetings from './pages/History/deletedMeetings';
import MobileDefaultRedirect from './components/MobileDefaultRedirect';
import LandingPage from './pages/LandingPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import ProtectedRoute from './components/ProtectedRoute';
import PublicLayout from './layout/Publiclayout';
import SupportPage from './pages/SupportPage';
import GoogleSiteVerificationPage from './pages/GoogleSiteVerificationPage';

function RedirectToTranscribe() {
  const location = useLocation();
  return <Navigate to={`/transcribe${location.search}`} replace />;
}

function AppRoute({ children }) {
  return <ProtectedRoute>{children}</ProtectedRoute>;
}

// Route configuration for the application
// Public routes are separated from authentication and protected app content.
// TranscribeDetail is still always mounted in App.js to preserve WebSocket and recording state.
export const router = createBrowserRouter([
  {
    path: '/googlee6d04b2c36165ca6.html',
    element: <GoogleSiteVerificationPage />,
  },
  {
    path: '/',
    element: <PublicLayout />,
    children: [
      { index: true, element: <LandingPage /> },
      { path: 'privacy', element: <PrivacyPolicyPage /> },
      { path: 'support', element: <SupportPage /> },
    ],
  },
  // {
  //   path: '/',
  //   element: <AuthLayout />,
  //   children: [
  //     {
  //       path: 'login',
  //       element: <LoginPage />,
  //     },
  //     {
  //       path: 'register',
  //       element: <RegisterPage />,
  //     },
  //     {
  //       path: 'forgot-password',
  //       element: <ForgotPasswordPage />,
  //     },
  //   ],
  // },
  {
    path: '/transcribe',
    element: (
      <AppRoute>
        <App />
      </AppRoute>
    ),
    children: [
      {
        index: true,
        element: <MobileDefaultRedirect />,
      },
      {
        path: 'home',
        element: null,
      },
      {
        path: 'history',
        element: <TranscriberHistory />,
      },
      {
        path: 'bin',
        element: <DeletedMeetings />,
      },
      {
        // Deleted meeting detail route - TranscriberDetail handles this via URL params
        // Outlet renders nothing for this route (empty element)
        path: 'bin/meeting/:meetingId',
        element: null,
      },
      {
        path: 'meeting/:meetingId',
        element: null,
      },
    ],
  },

  {
    // Redirect root to transcribe (preserve query params)
    path: '/',
    element: <RedirectToTranscribe />,
  },
  {
    // Catch all - redirect to transcribe (preserve query params)
    path: '*',
    element: <RedirectToTranscribe />,
  },
],
  {
    future: {
      v7_startTransition: true,
    },
  }
);
export { ROUTES } from './routePaths';
export { isTranscriptRoute } from './routePaths';
export { normalizeAppPathname } from './routePaths';
